import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Collapsible from 'react-collapsible';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { appConfig } from './../../configureApp';
import AsyncButton from 'components/AsyncButton';
import LoginPage from 'containers/Login';

import messages from './messages';
import StepAppsureBankDetails from '../FastCover/Appsure.StepBankDetails';
// import Step4 from '../FastCover/Step4';
import StepWhatHappened from '../FastCover/StepWhatHappened';
import StepCancellationAdditional from '../FastCover/StepCancellationAdditional';
import StepPersonalItems from '../FastCover/StepPersonalItems';
import StepOverseasMedical from '../FastCover/StepOverseasMedical';
import StepRentalVehicle from '../FastCover/StepRentalVehicle';
import StepSnowSports from '../FastCover/StepSnowSports';
import StepOther from '../FastCover/StepOther';
import StepSupportingDocuments from '../FastCover/StepSupportingDocuments';
import StepClaimSummary from '../FastCover/StepClaimSummary';
import Step16 from '../FastCover/Step16';
import Step17 from '../FastCover/Step17';
import StepTripCancellationAndTripInterruption from '../FastCover/StepTripCancellationAndTripInterruption';
import StepBaggageAndPersonalItems from '../FastCover/StepBaggageAndPersonalItems';
import StepMedicalExpenses from '../FastCover/StepMedicalExpenses';
import StepPaymentDetails from '../FastCover/StepPaymentDetails';
import MedicalExpenseStep from '../FastCover/Trawick.NationWide.MedicalExpenseStep/';
import AccidentalDeathAndDismemberment from '../FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/';
import TripCancellationStep from '../FastCover/Trawick.NationWide.TripCancellationStep/';
import TripDelayStep from '../FastCover/Trawick.NationWide.TripDelayStep/';
import TripInterruptionStep from '../FastCover/Trawick.NationWide.TripInterruptionStep/';
import MissedConnectionStep from '../FastCover/Trawick.NationWide.MissedConnectionStep/';
import PetMedicalStep from '../FastCover/Trawick.NationWide.PetMedicalStep/';
import CollisionDamageStep from '../FastCover/Trawick.NationWide.CollisionDamageStep/';
import PropertyDamageStep from '../FastCover/Trawick.NationWide.PropertyDamageStep/';
import BaggageAndPersonalStep from '../FastCover/Trawick.NationWide.PersonalItemStep/';
import SportsEquipmentStep from '../FastCover/Trawick.NationWide.SportsEquipmentStep/';
import MedicalHardshipStep from '../FastCover/Trawick.DuesProtect.MedicalHardshipStep/';
import JobLossHardshipStep from '../FastCover/Trawick.DuesProtect.JobLossHardshipStep/';
import MedicalExpenseCFStep from '../FastCover/Trawick.CFTripCan.MedicalExpense/';
import TripCancellationCFStep from '../FastCover/Trawick.CFTripCan.TripCancellationStep/';
import BaggagePersonalEffects from '../FastCover/Trawick.CFTripCan.BaggagePersonalEffects/';
import ItineraryChange from '../FastCover/Trawick.CFTripCan.ItineraryChange/';
import StepTravelDelay from '../FastCover/StepTravelDelay/';
import SubmissionScreen from '../FastCover/StepDeclaration';
import FieldHeader from '../FastCover/components/FieldHeader/index';
import { setAuthenticationToken } from '../Login/actions';
import { setSelectedPolicyId } from '../App/actions';
import {
  loadClaimFromSummary,
  updateSelectedClaimId,
  loadClaimList,
  downLoadSummary,
  updateSelectedClaimNumber,
  getShowElectronicConsent,
} from '../ClaimList/actions';
import { getClaimTypes } from '../FastCover/StepWhatHappened/actions';
import saga from '../ClaimList/saga';
import stepWhatHappenedSaga from '../FastCover/StepWhatHappened/saga';
import {
  makeSelectClaimList,
  makeSelectClaimTypes,
} from '../ClaimList/selectors';
import { makeSelectClaimPaymentVersion, makeSelectShowElectronicConsentDocument, makeSelectJSONVersion, makeSelectInitClaimTypeList, makeSelectShowRequiredDocument } from '../App/selectors';
import reducer from '../ClaimList/reducer';
import stepWhatHappenedReducer from '../FastCover/StepWhatHappened/reducer';
import injectReducer from '../../utils/injectReducer';
import loginSaga from '../Login/saga';
import loginReducer from '../Login/reducer';
import injectSaga from '../../utils/injectSaga';
import ModalNotice from '../FastCover/StepDeclaration/components/ModalNotice';
import apiConfig from '../../utils/apiConfig';
import { makeSelectStepWhatHappened } from '../FastCover/StepWhatHappened/selectors';
import { makeSelectStepOther } from '../FastCover/StepOther/selectors';
import { makeSelectStepTripCancellationAndTripInterruption } from '../FastCover/StepTripCancellationAndTripInterruption/selectors';
import { makeSelectStepDeclaration } from '../FastCover/StepDeclaration/selectors';
import {
  stepSnowSportsExpenseLookup,
  stepOtherExpenseLookup,
  stepTripCancellationAndTripInterruptionExpenseLookup,
  stepBaggageAndPersonalItemsExpenseLookup,
  stepMedicalExpensesExpenseLookup,
  stepCancellationAdditionalExpenseLookup,
  stepPersonalItemsExpenseLookup,
  stepOverseasMedicalExpenseLookup,
  stepRentalVehicleExpenseLookup,
  stepPetMedicalExpenseLookup,
  stepCollisionDamageExpenseLookup,
  stepPropertyDamageExpenseLookup,
  stepMedicalExpenseLookup,
  stepTripCancellationLookup,
  stepTripInterruptionLookup,
  stepTripDelayLookup,
  stepMissedConnectionLookup,
  stepAccidentalDeathAndDismembermentLookup,
  stepBaggageAndPersonalLookup,
  stepSportsEquipmentLookup,
  stepMedicalExpenseCFLookup,
  stepTripCancellationCFLookup,
  baggagePersonalEffectsLookup,
  itineraryChangeLookup,
  medicalHardshipLookup,
  jobLossHardshipLookup,
  disasterAssistanceHardshipLookup,
  stepTravelDelayLookup,
} from '../FastCover/dataMapper/claimCodeMapper';
import { makeDirty, makeError, makeValid } from '../Wizard/actions';
class SummaryScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      exporting: false,
      notice: false,
      claimNo: '',
      sections: [
        {
          id: 3,
          title: messages.section4,
          component: StepWhatHappened,
        },
        {
          id: 6,
          title: messages.section7,
          component: StepOverseasMedical,
        },
        {
          id: 5,
          title: messages.section6,
          component: StepPersonalItems,
        },
        {
          id: 4,
          title: messages.section5,
          component: StepCancellationAdditional,
        },
        {
          id: 7,
          title: messages.section8,
          component: StepRentalVehicle,
        },
        {
          id: 8,
          title: messages.section9,
          component: StepSnowSports,
        },
        {
          id: 20,
          title: messages.section20,
          component: StepMedicalExpenses,
        },
        {
          id: 18,
          title: messages.section18,
          component: StepTripCancellationAndTripInterruption,
        },
        {
          id: 19,
          title: messages.section19,
          component: StepBaggageAndPersonalItems,
        },
        {
          id: 9,
          title: messages.section10,
          component: StepOther,
        },
        // new screen
        {
          id: 16,
          title: messages.sectionPetMedicalStep,
          component: PetMedicalStep,
        },
        {
          id: 17,
          title: messages.sectionCollisionDamageStep,
          component: CollisionDamageStep,
        },
        {
          id: 21,
          title: messages.sectionPropertyDamage,
          component: PropertyDamageStep,
        },
        {
          id: 22,
          title: messages.sectionTripCancellation,
          component: TripCancellationStep,
        },
        {
          id: 23,
          title: messages.sectionMedicalExpenseStep,
          component: MedicalExpenseStep,
        },
        {
          id: 24,
          title: messages.sectionAccidentalDeathAndDismemberment,
          component: AccidentalDeathAndDismemberment,
        },
        {
          id: 25,
          title: messages.sectionTripDelayStep,
          component: TripDelayStep,
        },
        {
          id: 26,
          title: messages.sectionTripInterruptionStep,
          component: TripInterruptionStep,
        },
        {
          id: 27,
          title: messages.sectionMissedConnectionStep,
          component: MissedConnectionStep,
        },
        {
          id: 28,
          title: messages.sectionBaggageAndPersonalStep,
          component: BaggageAndPersonalStep,
        },
        {
          id: 29,
          title: messages.sectionSportsEquipmentStep,
          component: SportsEquipmentStep,
        },
        // {
        //   id: 30,
        //   title: messages.sectionMedicalHardshipStep,
        //   component: MedicalHardshipStep,
        // },
        // {
        //   id: 31,
        //   title: messages.sectionJobLossHardshipStep,
        //   component: JobLossHardshipStep,
        // },
        {
          id: 32,
          title: messages.sectionMedicalExpenseCFStep,
          component: MedicalExpenseCFStep,
        },
        {
          id: 33,
          title: messages.sectionTripCancellationCFStep,
          component: TripCancellationCFStep,
        },
        {
          id: 34,
          title: messages.sectionBaggagePersonalEffects,
          component: BaggagePersonalEffects,
        },
        {
          id: 35,
          title: messages.sectionItineraryChange,
          component: ItineraryChange,
        },
        {
          id: 36,
          title: messages.sectionTravelDelay,
          component: StepTravelDelay,
        },
        {
          id: 10,
          title: messages.section11,
          component: StepSupportingDocuments,
        },
        {
          id: 2,
          title: appConfig.showANZPayment === true ? messages.section2 : apiConfig.enableNewPaymentScreen === true ? messages.section2 : messages.section21,
          component: appConfig.showANZPayment === true ? StepAppsureBankDetails : apiConfig.enableNewPaymentScreen === true ? StepAppsureBankDetails : StepPaymentDetails,
        },
        {
          id: 15,
          title: messages.section15,
          component: StepClaimSummary,
        },
        {
          id: 11,
          title: messages.readyToSubmit,
          component: SubmissionScreen,
        },
      ],
    };
  }

  componentDidMount() {
    const { params } = this.props.match || {};
    this.props.onRequestClaimJson(params);
    this.props.loadClaimList();
    // this.props.getClaimTypes();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.claim &&
      nextProps.claim.claims &&
      nextProps.claim.claims.length
    ) {
      const { params } = this.props.match || {};
      const res = _.find(
        nextProps.claim.claims,
        (i) => i.claimParentId.toString() === params.claimNumber
      );
      this.setState({ claimNo: res.claimNumber });
      this.props.updateSelectedClaimNumber(res.claimNumber);
    }
  }

  showModal = () => {
    this.setState({ notice: true });
  };

  closeModal = () => {
    this.setState({ notice: false });
  };

  exportPdf = () => {
    this.setState({ exporting: true });
    this.showModal();
    const cb = () => {
      this.setState({ exporting: false });
      this.closeModal();
    };
    this.props.downLoadSummary(cb);
  };

  renderCollapsibleHeader = (message) => <FormattedMessage {...message} />;

  render() {
    const { notice, exporting, claimNo, sections } = this.state;
    const { params } = this.props.match || {};
    const { selectedBenefits } = this.props.form;
    const { claim, showElectronicConsentDocument, jsonVersion } = this.props;
    const { emailAddress } = this.props.stepDeclarationData;
    const selected =
      !!selectedBenefits && typeof selectedBenefits.toJS === 'function'
        ? selectedBenefits.toJS()
        : selectedBenefits || [];
    const errorEmails = null;

    return (
      <div className="summary_tbl_wrapper">
        <table
          style={{ marginTop: 20, marginBottom: 20 }}
          className="report-container"
        >
          <thead className="report-header">
            <tr>
              <td>
                <div
                  className="header-info"
                  style={{ textAlign: 'right', height: '70px' }}
                >
                  <img id="headerLogo" className="logo" width={'175px'} alt="Header Logo" />
                </div>
              </td>
            </tr>
          </thead>
          <tbody className="report-content">
            <tr>
              <td className="report-content-cell">
                <div style={{ overflow: 'hidden' }}>
                  <FieldHeader>
                    <FormattedMessage {...messages.sectionTitle} />
                  </FieldHeader>
                  {sections.map((section, index) => {
                    if (selected.length) {
                      if (
                        section.id === 4 &&
                        !_.intersection(
                          stepCancellationAdditionalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 5 &&
                        !_.intersection(
                          stepPersonalItemsExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 6 &&
                        !_.intersection(
                          stepOverseasMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 7 &&
                        !_.intersection(
                          stepRentalVehicleExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 8 &&
                        !_.intersection(
                          stepSnowSportsExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 9 &&
                        !_.intersection(
                          stepOtherExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 18 &&
                        !_.intersection(
                          stepTripCancellationAndTripInterruptionExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 19 &&
                        !_.intersection(
                          stepBaggageAndPersonalItemsExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 20 &&
                        !_.intersection(
                          stepMedicalExpensesExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 16 &&
                        !_.intersection(
                          stepPetMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 17 &&
                        !_.intersection(
                          stepCollisionDamageExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 21 &&
                        !_.intersection(
                          stepPropertyDamageExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 22 &&
                        !_.intersection(
                          stepTripCancellationLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 23 &&
                        !_.intersection(
                          stepMedicalExpenseLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 24 &&
                        !_.intersection(
                          stepAccidentalDeathAndDismembermentLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 25 &&
                        !_.intersection(
                          stepTripDelayLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 26 &&
                        !_.intersection(
                          stepTripInterruptionLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 27 &&
                        !_.intersection(
                          stepMissedConnectionLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 28 &&
                        !_.intersection(
                          stepBaggageAndPersonalLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 29 &&
                        !_.intersection(
                          stepSportsEquipmentLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 32 &&
                        !_.intersection(
                          stepMedicalExpenseCFLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 33 &&
                        !_.intersection(
                          stepTripCancellationCFLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 34 &&
                        !_.intersection(
                          baggagePersonalEffectsLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 35 &&
                        !_.intersection(
                          itineraryChangeLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 33 &&
                        !_.intersection(
                          medicalHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 34 &&
                        !_.intersection(
                          jobLossHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 35 &&
                        !_.intersection(
                          disasterAssistanceHardshipLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                      if (
                        section.id === 36 &&
                        !_.intersection(
                          stepTravelDelayLookup.claimCodeList,
                          _.map(selected, 'claimCode')
                        ).length
                      ) {
                        return null;
                      }
                    }
                    const Component = section.component;
                    return (
                      <div
                        key={index}
                        className={'pheader'}
                      >
                        {index === 0 && (
                          <div
                            className="text-center font-weight-bold mb-3 showOnPrint"
                            style={{ fontSize: 24 }}
                          >
                            <span>{claim.cellcaptive} Travel Claim Summary - </span>
                            <span>{claimNo}</span>
                          </div>
                        )}
                        <Collapsible
                          trigger={this.renderCollapsibleHeader(section.title)}
                          key={section.id}
                          open={index === 0}
                        >
                          <div>
                            <Component
                              summaryClaimNo={claimNo}
                              policyNumber={params.policyNumber}
                              token={this.props.match.params.token}
                              isSummary
                              signature
                              submitted
                              handleChange={() => {}}
                              {...this.props}
                              claimTypes={this.props.claimTypes}
                              stepWhatHappenedData={this.props.form}
                              stepOtherData={this.props.stepOtherData}
                              stepTripCancellationAndTripInterruptionData={this.props.stepTripCancellationAndTripInterruptionData}
                              showElectronicConsentDocument={showElectronicConsentDocument}
                              electronicConsentDocument
                              handleDownload={() => {}}
                              emailAddress={emailAddress}
                              errorEmails={errorEmails}
                              jsonVersion={jsonVersion}
                              claimTypesInit={this.props.claimTypesInit}
                              showRequiredDocument={this.props.showRequiredDocument}
                            />
                          </div>
                        </Collapsible>
                      </div>
                    );
                  })}
                </div>
                <ModalNotice isOpen={notice} onClose={this.closeModal} />
                <div className="d-none">
                  <LoginPage />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

SummaryScreen.propTypes = {
  onRequestClaimJson: PropTypes.func,
  loadClaimList: PropTypes.func,
  match: PropTypes.object,
  claim: PropTypes.object,
  downLoadSummary: PropTypes.func,
  updateSelectedClaimNumber: PropTypes.func,
  form: PropTypes.any,
  stepTripCancellationAndTripInterruptionData: PropTypes.any,
  stepOtherData: PropTypes.any,
  stepDeclarationData: PropTypes.any,
  claimTypes: PropTypes.any,
  claimPaymentVersion: PropTypes.any,
  showElectronicConsentDocument: PropTypes.bool,
  jsonVersion: PropTypes.string,
  claimTypesInit: PropTypes.array,
  showRequiredDocument: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  claim: makeSelectClaimList(),
  form: makeSelectStepWhatHappened(),
  stepTripCancellationAndTripInterruptionData: makeSelectStepTripCancellationAndTripInterruption(),
  stepOtherData: makeSelectStepOther(),
  stepDeclarationData: makeSelectStepDeclaration(),
  claimTypes: makeSelectClaimTypes(),
  claimPaymentVersion: makeSelectClaimPaymentVersion(),
  showElectronicConsentDocument: makeSelectShowElectronicConsentDocument(),
  jsonVersion: makeSelectJSONVersion(),
  claimTypesInit: makeSelectInitClaimTypeList(),
  showRequiredDocument: makeSelectShowRequiredDocument(),
});

function mapDispatchToProps(dispatch) {
  return {
    onRequestClaimJson: (params) => {
      dispatch(setAuthenticationToken(params.token));
      dispatch(setSelectedPolicyId(params.policyNumber));
      dispatch(updateSelectedClaimId(params.claimNumber));
      dispatch(getShowElectronicConsent());
      dispatch(loadClaimList());
      dispatch(loadClaimFromSummary());
      dispatch(getClaimTypes(true));
    },
    loadClaimList: () => dispatch(loadClaimList()),
    getClaimTypes: () => dispatch(getClaimTypes()),
    getShowElectronicConsent: () => dispatch(getShowElectronicConsent()),
    downLoadSummary: (cb) => dispatch(downLoadSummary(cb)),
    updateSelectedClaimNumber: (claimNumber) =>
      dispatch(updateSelectedClaimNumber(claimNumber)),
    makeError: (s) => dispatch(makeError(s)),
    makeDirty: (s) => dispatch(makeDirty(s)),
    makeValid: (s) => dispatch(makeValid(s)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

const withReducer = injectReducer({ key: 'claims', reducer });
const withStepWhatHappenedReducer = injectReducer({ key: 'stepWhatHappened', reducer: stepWhatHappenedReducer });
const withSaga = injectSaga({ key: 'claims', saga });
const withStepWhatHappenedSaga = injectSaga({ key: 'stepWhatHappened', saga: stepWhatHappenedSaga });
const withLoginSaga = injectSaga({ key: 'oauth', saga: loginSaga });
const withLoginReducer = injectReducer({ key: 'oauth', reducer: loginReducer });

export default compose(
  withStepWhatHappenedReducer,
  withReducer,
  withStepWhatHappenedSaga,
  withSaga,
  withLoginReducer,
  withLoginSaga,
  withConnect
)(SummaryScreen);



// WEBPACK FOOTER //
// ./app/containers/SummaryScreen/index.js